import G from "../../libs/Glob.mjs";
import AutoYNField from "./AutoYNField.mjs";

const AutoYNAField = class extends AutoYNField {
	constructor(props) {
		super(props);
		this.state.options.push( { value: '-', label: G.label('N.A.') } );
	}
}

export default AutoYNAField;